import { useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';

/**
 * IMPORTANT ARCHITECTURAL NOTE:
 * This hook ONLY opens the wallet connection modal without handling backend updates.
 * 
 * The actual wallet status listener and backend synchronization is handled by the
 * useWalletConnect hook, which is used in:
 * 1. WithdrawAmountModal (in AppHeader for MainLayout screens like Market, Friends, etc.)
 * 2. SettingsModule (for Settings screen which doesn't have AppHeader)
 * 
 * DO NOT REMOVE WithdrawAmountModal from AppHeader - it contains the critical
 * wallet status listener for all MainLayout screens!
 * 
 * This separation prevents duplicate API calls when multiple components need
 * wallet connection functionality.
 */
export const useWalletConnectModal = () => {
  const [tonConnectUI] = useTonConnectUI();
  const wallet = useTonWallet();

  // Handle wallet connection/disconnection - only opens modal, no backend update
  const openWalletModal = async () => {
    if (!wallet) {
      await tonConnectUI.openModal();
    }
  };

  return {
    wallet,
    openWalletModal,
  };
};